import React, { useEffect, useState } from 'react'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/swiper-bundle.css'
import './TheThao.scss'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import { getApiUrl } from '../../../../api/api'
import Loading from '../../../../component/Loading/Loading'
import Notify from '../../../../component/Notify/Notify'

const TheThao = () => {
  const [isLoading, setisLoading] = useState(false)
  const device = window.innerWidth > 540 ? 'd' : 'm'
  const [notiMessage, setNotiMessage] = useState('')
  const dangnhap = localStorage.getItem('dangnhap')

  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))

  const gameList = [
    {
      img: '/thethao/sbty_s.jpg?v=9512',
      onClick: () => goGame('SBTY_S', 'SBTY_S'),
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '44',
      gameid: '0'
    },
    {
      img: '/thethao/bti.jpg?v=9512',
      onClick: () => goGame('BTI', 'BTI'),
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '1022',
      gameid: '0'
    },

    {
      img: '/laptop/menu/thethao/sboitem.jfif',
      onClick: () => goGame('CMD', 'CMD'),
      portfolio: 'SportsBook',
      gameproviderid: null,
      gameid: null
    },
    {
      img: '/thethao/sbty_s.jpg?v=9512',
      onClick: () => goGame('SBTY_S', 'SBTY_S'),
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '44',
      gameid: '0'
    },
    {
      img: '/thethao/bti.jpg?v=9512',
      onClick: () => goGame('BTI', 'BTI'),
      portfolio: 'ThirdPartySportsBook',
      gameproviderid: '1022',
      gameid: '0'
    },

    {
      img: '/laptop/menu/thethao/sboitem.jfif',
      onClick: () => goGame('CMD', 'CMD'),
      portfolio: 'SportsBook',
      gameproviderid: null,
      gameid: null
    }
  ]

  function goGame (gameCode, gameName) {
    console.log(`Going to game: ${gameCode}, ${gameName}`)
  }

  const hanldePostWidthdraw = async (portfolio, gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio,
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  useEffect(() => {
    const swiper = new Swiper('.swiper-container', {
      modules: [Navigation],
      slidesPerView: 4, // Hiển thị 4 slide cùng lúc
      spaceBetween: 15, // Khoảng cách giữa các slide
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })

    return () => swiper.destroy(true, true)
  }, [])

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <div className='sp-box'>
        <Loading isLoading={isLoading} />
        <div className='container wrapthethao'>
          <div className='title'>
            <img src='/thethao/title.png' alt='Sports Title' />
          </div>

          <div
            className='swiper-button-prev'
            role='button'
            aria-label='Previous slide'
          ></div>

          <div className='swiper-container spframe'>
            <div id='spList' className='sp-game swiper-wrapper'>
              {gameList.map((game, index) => (
                <div key={index} className='item swiper-slide'>
                  <div className='pic'>
                    <img src={game.img} alt={`Game ${index}`} />

                    <div
                      className='btn button-yellow'
                      onClick={() => {
                        if (!dangnhap) {
                          setNotiMessage('Vui lòng đăng nhập để chơi game')
                        } else {
                          hanldePostWidthdraw(
                            game.portfolio,
                            game.gameproviderid,
                            game.gameid
                          )
                        }
                      }}
                    >
                      Vào trò chơi
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <span
              className='swiper-notification'
              aria-live='assertive'
              aria-atomic='true'
            ></span>
          </div>

          <div
            className='swiper-button-next'
            role='button'
            aria-label='Next slide'
          ></div>

          <div className='bottom-pic'>
            <img src='/thethao/bottom-pic.png' alt='Bottom Pic' />
          </div>
        </div>
      </div>
    </>
  )
}

export default TheThao
